import {
  BodyText,
  breakpoint,
  ButtonRow,
  LinkTextStyles,
  SecondaryButton,
} from '@grays-npm/component-library';
import styled from 'styled-components';
import { Modal, ModalProps } from '../../../components';
import { useCMSData } from '../../../state/content-manager';

type ReferredInfoModalProps = Omit<ModalProps, 'title'>;

const PrimaryText = styled(BodyText)`
  margin: 0 0 ${({ theme }) => theme.spacings[4].rem};

  ${breakpoint('sm')`
    margin: ${({ theme: { spacings } }) =>
      `0 ${spacings[5].rem} ${spacings[4].rem} 0`};
  `}
`;

const SecondaryText = styled(BodyText)`
  margin: 0 0 ${({ theme }) => theme.spacings[7].rem};

  ${breakpoint('sm')`
    margin: ${({ theme: { spacings } }) =>
      `0 ${spacings[5].rem} ${spacings[7].rem} 0`};
  `}

  a {
    ${LinkTextStyles}
  }
`;

const Button = styled(SecondaryButton)`
  min-width: 120px;
`;

export const ReferredInfoModal: React.FC<ReferredInfoModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { title, body, subBody } = useCMSData().modals.referredInfo;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      <PrimaryText size="lg">{body}</PrimaryText>
      {subBody && (
        <SecondaryText
          styleType="body"
          context="secondary"
          size="md"
          isUnderlined={false}
        >
          <span dangerouslySetInnerHTML={{ __html: subBody }}></span>
        </SecondaryText>
      )}
      <ButtonRow>
        <Button fullWidth={false} onClick={onClose} size="large">
          Ok, got it!
        </Button>
      </ButtonRow>
    </Modal>
  );
};
